/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { AddQuizsetFolderItemReq } from '../_model/addQuizsetFolderItemReq';
import type { CreateQuizsetFolderReq } from '../_model/createQuizsetFolderReq';
import type { GetSitemapEntriesParams } from '../_model/getSitemapEntriesParams';
import type { ListMineParams } from '../_model/listMineParams';
import type { QuizsetFolderPlayNextReq } from '../_model/quizsetFolderPlayNextReq';
import type { QuizsetFolderPlayStartReq } from '../_model/quizsetFolderPlayStartReq';
import type { QuizsetSearchReq } from '../_model/quizsetSearchReq';
import type { ReorderQuizsetFolderItemsReq } from '../_model/reorderQuizsetFolderItemsReq';
import type { SearchResponseListSearchQuizsetFolderRes } from '../_model/searchResponseListSearchQuizsetFolderRes';
import type { SuccessBody } from '../_model/successBody';
import type { SuccessBodyListString } from '../_model/successBodyListString';
import type { SuccessBodyQuizsetFolderCursorPage } from '../_model/successBodyQuizsetFolderCursorPage';
import type { SuccessBodyQuizsetFolderNextRes } from '../_model/successBodyQuizsetFolderNextRes';
import type { SuccessBodyQuizsetFolderPlayStartRes } from '../_model/successBodyQuizsetFolderPlayStartRes';
import type { SuccessBodyQuizsetFolderRes } from '../_model/successBodyQuizsetFolderRes';
import type { SuccessBodySeoSitemapPageQuizsetFolderSitemapEntry } from '../_model/successBodySeoSitemapPageQuizsetFolderSitemapEntry';
import type { UpdateQuizsetFolderNameReq } from '../_model/updateQuizsetFolderNameReq';
import type { UpdateQuizsetFolderVisibilityReq } from '../_model/updateQuizsetFolderVisibilityReq';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const reorderItems = (
  id: string,
  reorderQuizsetFolderItemsReq: BodyType<ReorderQuizsetFolderItemsReq>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    {
      url: `/quizset-folders/${id}/items/order`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: reorderQuizsetFolderItemsReq,
    },
    options,
  );
};

export const getReorderItemsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reorderItems>>,
    TError,
    { id: string; data: BodyType<ReorderQuizsetFolderItemsReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reorderItems>>,
  TError,
  { id: string; data: BodyType<ReorderQuizsetFolderItemsReq> },
  TContext
> => {
  const mutationKey = ['reorderItems'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reorderItems>>,
    { id: string; data: BodyType<ReorderQuizsetFolderItemsReq> }
  > = props => {
    const { id, data } = props ?? {};

    return reorderItems(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReorderItemsMutationResult = NonNullable<
  Awaited<ReturnType<typeof reorderItems>>
>;
export type ReorderItemsMutationBody = BodyType<ReorderQuizsetFolderItemsReq>;
export type ReorderItemsMutationError = ErrorType<unknown>;

export const useReorderItems = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reorderItems>>,
      TError,
      { id: string; data: BodyType<ReorderQuizsetFolderItemsReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof reorderItems>>,
  TError,
  { id: string; data: BodyType<ReorderQuizsetFolderItemsReq> },
  TContext
> => {
  const mutationOptions = getReorderItemsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const create = (
  createQuizsetFolderReq: BodyType<CreateQuizsetFolderReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    {
      url: `/quizset-folders`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createQuizsetFolderReq,
      signal,
    },
    options,
  );
};

export const getCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof create>>,
    TError,
    { data: BodyType<CreateQuizsetFolderReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof create>>,
  TError,
  { data: BodyType<CreateQuizsetFolderReq> },
  TContext
> => {
  const mutationKey = ['create'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof create>>,
    { data: BodyType<CreateQuizsetFolderReq> }
  > = props => {
    const { data } = props ?? {};

    return create(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof create>>
>;
export type CreateMutationBody = BodyType<CreateQuizsetFolderReq>;
export type CreateMutationError = ErrorType<unknown>;

export const useCreate = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof create>>,
      TError,
      { data: BodyType<CreateQuizsetFolderReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof create>>,
  TError,
  { data: BodyType<CreateQuizsetFolderReq> },
  TContext
> => {
  const mutationOptions = getCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const start = (
  id: string,
  quizsetFolderPlayStartReq: BodyType<QuizsetFolderPlayStartReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderPlayStartRes>(
    {
      url: `/quizset-folders/${id}/play/start`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetFolderPlayStartReq,
      signal,
    },
    options,
  );
};

export const getStartMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof start>>,
    TError,
    { id: string; data: BodyType<QuizsetFolderPlayStartReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof start>>,
  TError,
  { id: string; data: BodyType<QuizsetFolderPlayStartReq> },
  TContext
> => {
  const mutationKey = ['start'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof start>>,
    { id: string; data: BodyType<QuizsetFolderPlayStartReq> }
  > = props => {
    const { id, data } = props ?? {};

    return start(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartMutationResult = NonNullable<
  Awaited<ReturnType<typeof start>>
>;
export type StartMutationBody = BodyType<QuizsetFolderPlayStartReq>;
export type StartMutationError = ErrorType<unknown>;

export const useStart = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof start>>,
      TError,
      { id: string; data: BodyType<QuizsetFolderPlayStartReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof start>>,
  TError,
  { id: string; data: BodyType<QuizsetFolderPlayStartReq> },
  TContext
> => {
  const mutationOptions = getStartMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const next = (
  id: string,
  quizsetFolderPlayNextReq: BodyType<QuizsetFolderPlayNextReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderNextRes>(
    {
      url: `/quizset-folders/${id}/play/next`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetFolderPlayNextReq,
      signal,
    },
    options,
  );
};

export const getNextMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof next>>,
    TError,
    { id: string; data: BodyType<QuizsetFolderPlayNextReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof next>>,
  TError,
  { id: string; data: BodyType<QuizsetFolderPlayNextReq> },
  TContext
> => {
  const mutationKey = ['next'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof next>>,
    { id: string; data: BodyType<QuizsetFolderPlayNextReq> }
  > = props => {
    const { id, data } = props ?? {};

    return next(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NextMutationResult = NonNullable<Awaited<ReturnType<typeof next>>>;
export type NextMutationBody = BodyType<QuizsetFolderPlayNextReq>;
export type NextMutationError = ErrorType<unknown>;

export const useNext = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof next>>,
      TError,
      { id: string; data: BodyType<QuizsetFolderPlayNextReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof next>>,
  TError,
  { id: string; data: BodyType<QuizsetFolderPlayNextReq> },
  TContext
> => {
  const mutationOptions = getNextMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const addItem = (
  id: string,
  addQuizsetFolderItemReq: BodyType<AddQuizsetFolderItemReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    {
      url: `/quizset-folders/${id}/items`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addQuizsetFolderItemReq,
      signal,
    },
    options,
  );
};

export const getAddItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addItem>>,
    TError,
    { id: string; data: BodyType<AddQuizsetFolderItemReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addItem>>,
  TError,
  { id: string; data: BodyType<AddQuizsetFolderItemReq> },
  TContext
> => {
  const mutationKey = ['addItem'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addItem>>,
    { id: string; data: BodyType<AddQuizsetFolderItemReq> }
  > = props => {
    const { id, data } = props ?? {};

    return addItem(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof addItem>>
>;
export type AddItemMutationBody = BodyType<AddQuizsetFolderItemReq>;
export type AddItemMutationError = ErrorType<unknown>;

export const useAddItem = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addItem>>,
      TError,
      { id: string; data: BodyType<AddQuizsetFolderItemReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addItem>>,
  TError,
  { id: string; data: BodyType<AddQuizsetFolderItemReq> },
  TContext
> => {
  const mutationOptions = getAddItemMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const searchMine = (
  quizsetSearchReq: BodyType<QuizsetSearchReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SearchResponseListSearchQuizsetFolderRes>(
    {
      url: `/quizset-folders/my/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizsetSearchReq,
      signal,
    },
    options,
  );
};

export const getSearchMineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchMine>>,
    TError,
    { data: BodyType<QuizsetSearchReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchMine>>,
  TError,
  { data: BodyType<QuizsetSearchReq> },
  TContext
> => {
  const mutationKey = ['searchMine'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchMine>>,
    { data: BodyType<QuizsetSearchReq> }
  > = props => {
    const { data } = props ?? {};

    return searchMine(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchMineMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchMine>>
>;
export type SearchMineMutationBody = BodyType<QuizsetSearchReq>;
export type SearchMineMutationError = ErrorType<unknown>;

export const useSearchMine = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchMine>>,
      TError,
      { data: BodyType<QuizsetSearchReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchMine>>,
  TError,
  { data: BodyType<QuizsetSearchReq> },
  TContext
> => {
  const mutationOptions = getSearchMineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateVisibility = (
  id: string,
  updateQuizsetFolderVisibilityReq: BodyType<UpdateQuizsetFolderVisibilityReq>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    {
      url: `/quizset-folders/${id}/visibility`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateQuizsetFolderVisibilityReq,
    },
    options,
  );
};

export const getUpdateVisibilityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVisibility>>,
    TError,
    { id: string; data: BodyType<UpdateQuizsetFolderVisibilityReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVisibility>>,
  TError,
  { id: string; data: BodyType<UpdateQuizsetFolderVisibilityReq> },
  TContext
> => {
  const mutationKey = ['updateVisibility'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVisibility>>,
    { id: string; data: BodyType<UpdateQuizsetFolderVisibilityReq> }
  > = props => {
    const { id, data } = props ?? {};

    return updateVisibility(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVisibilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVisibility>>
>;
export type UpdateVisibilityMutationBody =
  BodyType<UpdateQuizsetFolderVisibilityReq>;
export type UpdateVisibilityMutationError = ErrorType<unknown>;

export const useUpdateVisibility = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateVisibility>>,
      TError,
      { id: string; data: BodyType<UpdateQuizsetFolderVisibilityReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateVisibility>>,
  TError,
  { id: string; data: BodyType<UpdateQuizsetFolderVisibilityReq> },
  TContext
> => {
  const mutationOptions = getUpdateVisibilityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateName = (
  id: string,
  updateQuizsetFolderNameReq: BodyType<UpdateQuizsetFolderNameReq>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    {
      url: `/quizset-folders/${id}/name`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateQuizsetFolderNameReq,
    },
    options,
  );
};

export const getUpdateNameMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateName>>,
    TError,
    { id: string; data: BodyType<UpdateQuizsetFolderNameReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateName>>,
  TError,
  { id: string; data: BodyType<UpdateQuizsetFolderNameReq> },
  TContext
> => {
  const mutationKey = ['updateName'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateName>>,
    { id: string; data: BodyType<UpdateQuizsetFolderNameReq> }
  > = props => {
    const { id, data } = props ?? {};

    return updateName(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateName>>
>;
export type UpdateNameMutationBody = BodyType<UpdateQuizsetFolderNameReq>;
export type UpdateNameMutationError = ErrorType<unknown>;

export const useUpdateName = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateName>>,
      TError,
      { id: string; data: BodyType<UpdateQuizsetFolderNameReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateName>>,
  TError,
  { id: string; data: BodyType<UpdateQuizsetFolderNameReq> },
  TContext
> => {
  const mutationOptions = getUpdateNameMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const get = (
  id: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    { url: `/quizset-folders/${id}`, method: 'GET', signal },
    options,
  );
};

export const getGetQueryKey = (id: string) => {
  return [`/quizset-folders/${id}`] as const;
};

export const getGetQueryOptions = <
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof get>>> = ({
    signal,
  }) => get(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetQueryResult = NonNullable<Awaited<ReturnType<typeof get>>>;
export type GetQueryError = ErrorType<unknown>;

export function useGet<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get>>,
          TError,
          Awaited<ReturnType<typeof get>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGet<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get>>,
          TError,
          Awaited<ReturnType<typeof get>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGet<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGet<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof get>>> = ({
    signal,
  }) => get(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof get>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof get>>
>;
export type GetSuspenseQueryError = ErrorType<unknown>;

export function useGetSuspense<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSuspense<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSuspense<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetSuspense<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const _delete = (
  id: string,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBody>(
    { url: `/quizset-folders/${id}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof _delete>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof _delete>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['_delete'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof _delete>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return _delete(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type _DeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof _delete>>
>;

export type _DeleteMutationError = ErrorType<unknown>;

export const useDelete = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof _delete>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof _delete>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getSitemapEntries = (
  params: GetSitemapEntriesParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodySeoSitemapPageQuizsetFolderSitemapEntry>(
    { url: `/quizset-folders/sitemap-entries`, method: 'GET', params, signal },
    options,
  );
};

export const getGetSitemapEntriesQueryKey = (
  params: GetSitemapEntriesParams,
) => {
  return [
    `/quizset-folders/sitemap-entries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSitemapEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSitemapEntriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSitemapEntries>>
  > = ({ signal }) => getSitemapEntries(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSitemapEntries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSitemapEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSitemapEntries>>
>;
export type GetSitemapEntriesQueryError = ErrorType<unknown>;

export function useGetSitemapEntries<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSitemapEntries>>,
          TError,
          Awaited<ReturnType<typeof getSitemapEntries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSitemapEntries<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSitemapEntries>>,
          TError,
          Awaited<ReturnType<typeof getSitemapEntries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSitemapEntries<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSitemapEntries<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSitemapEntriesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSitemapEntriesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSitemapEntriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSitemapEntries>>
  > = ({ signal }) => getSitemapEntries(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSitemapEntries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSitemapEntriesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSitemapEntries>>
>;
export type GetSitemapEntriesSuspenseQueryError = ErrorType<unknown>;

export function useGetSitemapEntriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSitemapEntriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSitemapEntriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetSitemapEntriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapEntries>>,
  TError = ErrorType<unknown>,
>(
  params: GetSitemapEntriesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapEntries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetSitemapEntriesSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSitemapCountries = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListString>(
    { url: `/quizset-folders/sitemap-countries`, method: 'GET', signal },
    options,
  );
};

export const getGetSitemapCountriesQueryKey = () => {
  return [`/quizset-folders/sitemap-countries`] as const;
};

export const getGetSitemapCountriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSitemapCountries>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSitemapCountriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSitemapCountries>>
  > = ({ signal }) => getSitemapCountries(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSitemapCountries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSitemapCountriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSitemapCountries>>
>;
export type GetSitemapCountriesQueryError = ErrorType<unknown>;

export function useGetSitemapCountries<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSitemapCountries>>,
          TError,
          Awaited<ReturnType<typeof getSitemapCountries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSitemapCountries<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSitemapCountries>>,
          TError,
          Awaited<ReturnType<typeof getSitemapCountries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSitemapCountries<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetSitemapCountries<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetSitemapCountriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSitemapCountriesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getSitemapCountries>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSitemapCountriesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSitemapCountries>>
  > = ({ signal }) => getSitemapCountries(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSitemapCountries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSitemapCountriesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSitemapCountries>>
>;
export type GetSitemapCountriesSuspenseQueryError = ErrorType<unknown>;

export function useGetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetSitemapCountriesSuspense<
  TData = Awaited<ReturnType<typeof getSitemapCountries>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSitemapCountries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetSitemapCountriesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const listMine = (
  params?: ListMineParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderCursorPage>(
    { url: `/quizset-folders/my`, method: 'GET', params, signal },
    options,
  );
};

export const getListMineQueryKey = (params?: ListMineParams) => {
  return [`/quizset-folders/my`, ...(params ? [params] : [])] as const;
};

export const getListMineQueryOptions = <
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMine>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMineQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMine>>> = ({
    signal,
  }) => listMine(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMine>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListMineQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMine>>
>;
export type ListMineQueryError = ErrorType<unknown>;

export function useListMine<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ListMineParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMine>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMine>>,
          TError,
          Awaited<ReturnType<typeof listMine>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMine<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMine>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMine>>,
          TError,
          Awaited<ReturnType<typeof listMine>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListMine<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMine>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useListMine<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMine>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListMineQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListMineSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listMine>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMineQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMine>>> = ({
    signal,
  }) => listMine(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listMine>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListMineSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMine>>
>;
export type ListMineSuspenseQueryError = ErrorType<unknown>;

export function useListMineSuspense<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ListMineParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listMine>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMineSuspense<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listMine>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMineSuspense<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listMine>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useListMineSuspense<
  TData = Awaited<ReturnType<typeof listMine>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMineParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listMine>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getListMineSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const removeItem = (
  id: string,
  quizsetId: string,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBodyQuizsetFolderRes>(
    { url: `/quizset-folders/${id}/items/${quizsetId}`, method: 'DELETE' },
    options,
  );
};

export const getRemoveItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeItem>>,
    TError,
    { id: string; quizsetId: string },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeItem>>,
  TError,
  { id: string; quizsetId: string },
  TContext
> => {
  const mutationKey = ['removeItem'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeItem>>,
    { id: string; quizsetId: string }
  > = props => {
    const { id, quizsetId } = props ?? {};

    return removeItem(id, quizsetId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeItem>>
>;

export type RemoveItemMutationError = ErrorType<unknown>;

export const useRemoveItem = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeItem>>,
      TError,
      { id: string; quizsetId: string },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeItem>>,
  TError,
  { id: string; quizsetId: string },
  TContext
> => {
  const mutationOptions = getRemoveItemMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const clearExcludedQuizsets = (
  id: string,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBody>(
    { url: `/quizset-folders/${id}/excluded-quizsets`, method: 'DELETE' },
    options,
  );
};

export const getClearExcludedQuizsetsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearExcludedQuizsets>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clearExcludedQuizsets>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['clearExcludedQuizsets'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clearExcludedQuizsets>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return clearExcludedQuizsets(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearExcludedQuizsetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearExcludedQuizsets>>
>;

export type ClearExcludedQuizsetsMutationError = ErrorType<unknown>;

export const useClearExcludedQuizsets = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof clearExcludedQuizsets>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof clearExcludedQuizsets>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getClearExcludedQuizsetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
